function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".rider-journey-chart{font-family:sans-serif}.rider-journey-chart path{fill:#787878;fill-opacity:1}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "rider-journey-chart"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2443.324 602.07h-37.5c-32.667 0-37.5.194-37.5 1.5 0 1.333-118.945 1.5-1064.5 1.5-585.475 0-1064.5-.21-1064.5-.465 0-.256 26.57-59.059 59.047-130.672l59.047-130.207-58.712-129.578C266.415 142.88 239.816 84.233 239.6 83.82c-.217-.412 495.532-.75 1101.665-.75h1102.059",
  className: "path1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2464.324 83.055l885.25.285c828.849.267 886.237.394 900.75 2.002 84.314 9.341 151.268 28.373 222.5 63.245 134.414 65.805 242.05 177.733 303.047 315.13 30.142 67.898 47.912 139.802 53.468 216.353 1.107 15.254 1.247 27.419.354 30.75l-.603 2.25h-259.824c-142.903 0-260.028-.337-260.276-.75-.249-.412-.942-3.934-1.541-7.826-7.005-45.506-41.43-83.723-86.625-96.17l-10-2.754-815.75-.254c-723.303-.225-815.75-.424-815.75-1.75 0-1.31-7.129-1.496-57.5-1.496h-57.5",
  className: "path2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2535.324 1362.08c0-.66-12.27-1.01-35.5-1.01h-35.5v-518h37c23.882 0 37-.353 37-.995 0-.66 281.925-1.093 835.25-1.284 780.926-.27 835.686-.398 841.962-1.981 37.97-9.578 65.673-31.686 81.952-65.403 4.785-9.91 9.336-24.766 10.672-34.837l.664-5 260.25-.252 260.25-.252.233 8.252c.887 31.382-4.72 78.885-14.371 121.752-52.717 234.138-231.803 419.072-464.362 479.526-31.764 8.256-66.506 14.323-104 18.158-15.981 1.635-67.805 1.757-864.25 2.038-569.869.2-847.25-.032-847.25-.712z",
  className: "path3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.847 1466.82c.218-1.787.633-10 .922-18.25 2.932-83.678 27.613-176.615 68.12-256.5 76.239-150.355 208.96-264.92 368.435-318.029 53.964-17.972 110.692-28.757 168-31.942 25.349-1.408 1704-1.437 1704-.029 0 .648 12.166 1 34.5 1h34.5v518h-53c-34.667 0-53 .346-53 1 0 .666-274.254 1.002-820.75 1.006-901.334.01-830.046-.493-849.29 5.955-40.808 13.671-71.585 49.427-79.01 91.79-.834 4.76-1.73 7.25-2.61 7.25-.737 0-1.34.45-1.34 1 0 .663-87.313 1-259.937 1H64.449z",
  className: "path4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M669.324 2120.416c-62.362-4.23-112.45-13.793-166.547-31.801-162.455-54.08-295.116-169.246-370.964-322.045-40.456-81.501-62.52-166.78-66.407-256.668-.412-9.532-.573-17.67-.357-18.082.216-.412 117.141-.75 259.834-.75 229.947 0 259.44.17 259.44 1.5 0 .825.635 1.5 1.41 1.5.973 0 1.784 2.249 2.615 7.25 3.621 21.79 14.438 43.406 30.13 60.209 17.499 18.737 41.268 31.782 65.727 36.071 7.33 1.286 118.086 1.47 883.75 1.47h875.369v522l-884.75-.175c-486.613-.095-886.775-.311-889.25-.48z",
  className: "path5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4307.43 2220.82c-1.548-10.293-6.97-26.792-11.876-36.137-18.062-34.404-52.92-58.184-91.73-62.578-6.043-.684-293.343-1.021-874.25-1.027l-865.25-.01v-522.027l880.25.313c954.636.34 885.857-.047 926.943 5.207 110.085 14.078 215.79 57.113 304.307 123.89 40.61 30.636 82.825 71.702 115.056 111.924 84.112 104.965 134.228 238.77 139.122 371.443l.637 17.25H4308.67z",
  className: "path6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2469.574 2879.338l-4.25-.383v-520.873l870.25-.291c816.431-.273 870.712-.396 877.725-1.999 23.83-5.444 41.772-14.938 58.801-31.114 18.913-17.966 32.278-43.858 35.67-69.108l.673-5 261.097.254 261.098.254-.654 17.319c-4.116 109.103-38.42 218.39-98.528 313.889-49.109 78.024-118.657 147.766-196.67 197.218-96.513 61.18-203.31 94.593-318.185 99.55-21.452.925-1736.808 1.204-1747.027.284z",
  className: "path7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.809 2982.822c.246-2.339.686-10.813.977-18.831 1.378-37.949 8.472-84.805 18.99-125.42 11.934-46.093 25.773-83.162 47.037-126 69.587-140.187 187.774-249.51 333.464-308.454 54.864-22.198 112.506-36.283 179.047-43.753 14.593-1.638 67.64-1.756 907.25-2.024l891.75-.285v520.726l-6.75.638c-3.713.35-397.629.64-875.37.644-759.703.01-869.67.192-877 1.477-36.574 6.415-68.748 30.84-85.657 65.03-5.014 10.14-7.847 18.78-10.041 30.629l-1.735 9.371-261.205.252-261.205.252z",
  className: "path8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M667.324 3636.958c-124.516-7.025-247.728-52.411-347.89-128.148-125.98-95.26-211.718-231.983-242.52-386.74-6.32-31.755-10.145-63.553-11.398-94.752l-.692-17.253 260.954.253 260.954.252 1.804 9c5.1 25.447 16.325 46.14 34.487 63.576 17.757 17.048 39.488 27.891 62.997 31.435 8.591 1.295 117.862 1.478 883.554 1.483l873.75.01v520.711l-6.75.638c-10.032.947-1752.333.494-1769.25-.46z",
  className: "path9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2470.574 3637.387l-6.25-.412v-521.131l1119.471.37c990.986.329 1119.628.543 1120.833 1.864 2.461 2.7 115.867 258.229 115.399 260.02-.936 3.578-114.092 256.53-115.398 257.964-1.203 1.32-129.33 1.505-1114.582 1.614-612.273.068-1116.036-.062-1119.473-.29z",
  className: "path10"
}), /*#__PURE__*/React.createElement("g", {
  className: "circle"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path1015",
  cx: 320,
  cy: 1465,
  r: 183,
  className: "circle",
  fill: "#fff",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("text", {
  x: 320,
  y: 1465,
  textAnchor: "middle",
  fontSize: 240,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "40")), /*#__PURE__*/React.createElement("g", {
  className: "circle"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path1015",
  cx: 320,
  cy: 2998,
  r: 183,
  className: "circle",
  fill: "#fff",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("text", {
  x: 320,
  y: 2998,
  textAnchor: "middle",
  fontSize: 240,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "80")), /*#__PURE__*/React.createElement("g", {
  className: "circle"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path1015",
  cx: 4564,
  cy: 736,
  r: 183,
  className: "circle",
  fill: "#fff",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("text", {
  x: 4564,
  y: 736,
  textAnchor: "middle",
  fontSize: 240,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "20")), /*#__PURE__*/React.createElement("g", {
  className: "circle"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path1015",
  cx: 4564,
  cy: 2254,
  r: 183,
  className: "circle",
  fill: "#fff",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("text", {
  x: 4564,
  y: 2254,
  textAnchor: "middle",
  fontSize: 240,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "60")), /*#__PURE__*/React.createElement("g", {
  className: "circle"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path1015",
  cx: 4564,
  cy: 3376,
  r: 183,
  className: "circle",
  fill: "#fff",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("text", {
  x: 4564,
  y: 3376,
  textAnchor: "middle",
  fontSize: "140pt",
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "100")), /*#__PURE__*/React.createElement("text", {
  y: 343,
  x: 1400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "INTRO"), /*#__PURE__*/React.createElement("text", {
  y: 1111,
  x: 1400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "STAR"), /*#__PURE__*/React.createElement("text", {
  y: 1863,
  x: 1400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "CHAMP"), /*#__PURE__*/React.createElement("text", {
  y: 2623,
  x: 1400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "PRO"), /*#__PURE__*/React.createElement("text", {
  y: 3375,
  x: 1400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "MASTER"), /*#__PURE__*/React.createElement("text", {
  y: 343,
  x: 3400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "INTER"), /*#__PURE__*/React.createElement("text", {
  y: 1111,
  x: 3400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "ADV"), /*#__PURE__*/React.createElement("text", {
  y: 1863,
  x: 3400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "ACE"), /*#__PURE__*/React.createElement("text", {
  y: 2623,
  x: 3400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "EXPERT"), /*#__PURE__*/React.createElement("text", {
  y: 3375,
  x: 3400,
  textAnchor: "middle",
  fontSize: 200,
  alignmentBaseline: "central",
  dominantBaseline: "central"
}, "ALIEN"));

function SvgRiderJourneyChart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4895 3721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiderJourneyChart);
export default __webpack_public_path__ + "static/media/Rider Journey Chart.029d0fcf.svg";
export { ForwardRef as ReactComponent };